import * as React from "react";
import Box from "@mui/material/Box";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Card, useTheme } from "@mui/material";
import code from "../assets/code.svg";
import code1 from "../assets/code1.svg";

export const AboutUs = () => {
  const theme = useTheme();
  return (
    <>
      <Container
        data-aos="fade-up"
        data-aos-duration="2000"
        id="aboutus"
        sx={{
          pt: { xs: 8, sm: 10 },
          pb: { xs: 4, sm: 5 },
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "center", md: "center" },
          }}
        >
          <Typography
            component="div"
            variant="body1"
            textAlign="center"
            sx={{
              color:
                theme.palette.mode === "light"
                  ? theme.palette.secondary.main
                  : "#9043c6",
              fontWeight: "bold",
            }}
          >
            WHAT IS SNYPRS
          </Typography>
          <Typography
            component="h2"
            variant="h4"
            color="text.primary"
            fontWeight="bold"
            textAlign="center"
            sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
          >
            We love transforming product ideas to digital realities.
          </Typography>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            We develop impactful products tailored for individuals,
            entrepreneurs, startups, businesses, and enterprises with a premier
            software development firm.
          </Typography>
        </Box>
        <Box>
          <Grid
            container
            spacing={1.5}
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <Grid item sx={{ display: "flex" }} xs={12} md={6}>
              <Card
                variant=""
                sx={{
                  p: 3,
                  background: "none",
                  border: "none",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: { xs: "left", sm: "center" },
                }}
              >
                <Typography
                  component="h2"
                  variant="h5"
                  color="text.primary"
                  fontWeight="bold"
                  textAlign="center"
                  sx={{
                    lineHeight: { xs: "1.5rem" },
                    mt: 2,
                    mb: 2,
                    textAlign: { xs: "left", sm: "center" },
                  }}
                >
                  Transforming your business idea into a tangible software
                  solution.
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: { xs: "left", sm: "center" } }}
                >
                  Our software development service blends code and creativity,
                  crafting robust, user-friendly applications tailored to your
                  needs. From conception to deployment, we drive your goals
                  forward with expertise and innovation.
                </Typography>
              </Card>
            </Grid>
            <Grid item sx={{ display: "flex" }} xs={12} md={6}>
              <Card
                variant=""
                sx={{
                  p: 3,
                  height: "fit-content",
                  width: "200%",
                  background: "none",
                  border: "none",
                }}
              >
                <Typography
                  color="text.primary"
                  variant="body2"
                  fontWeight="bold"
                >
                  <img src={code} width="100%" alt="code" />
                </Typography>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1.5}
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <Grid
              item
              sx={{ display: "flex" }}
              xs={12}
              md={6}
              order={{ xs: 2, md: 1 }}
            >
              <Card
                variant=""
                sx={{
                  p: 3,
                  height: "fit-content",
                  width: "200%",
                  background: "none",
                  border: "none",
                }}
              >
                <Typography
                  color="text.primary"
                  variant="body2"
                  fontWeight="bold"
                >
                  <img src={code1} width="100%" alt="code1" />
                </Typography>
              </Card>
            </Grid>
            <Grid
              item
              sx={{ display: "flex" }}
              xs={12}
              md={6}
              order={{ xs: 1, md: 2 }}
            >
              <Card
                variant=""
                sx={{
                  p: 3,
                  background: "none",
                  border: "none",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: { xs: "left", sm: "center" },
                }}
              >
                <Typography
                  component="h2"
                  variant="h5"
                  color="text.primary"
                  fontWeight="bold"
                  textAlign="center"
                  sx={{
                    lineHeight: { xs: "1.5rem" },
                    mt: 2,
                    mb: 2,
                    textAlign: { xs: "left", sm: "center" },
                  }}
                >
                  Developing scalable, subscription-based software solutions for
                  business efficiency and growth.
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: { xs: "left", sm: "center" } }}
                >
                  We designed to optimize workflows, reduce overhead costs, and
                  provide flexible subscription-based solutions for businesses
                  of all sizes.
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};
